import React, { useContext } from 'react';
import { Platform, StyleSheet, Text } from 'react-native';
import PropTypes from 'prop-types';
import LayoutContext from '../../contexts/Layout';

const Link = ({ onPress, style, text }) => {
    const { layout } = useContext(LayoutContext);

    return (
        <Text
            adjustsFontSizeToFit={true}
            dataSet={{
                tagName: 'Link',
                fontFamily: layout.styleGuide.link.fontFamily,
                condensedFontFamily: layout.styleGuide.link.condensedFontFamily,
                fontSize: layout.styleGuide.link.fontSize,
                color: layout.styleGuide.link.color
            }}
            numberOfLines={1}
            onPress={onPress}
            style={StyleSheet.flatten([Style.link, layout.styleGuide.link, style])}
        >
            {text}
        </Text>
    );
};

const Style = StyleSheet.create({
    link: {
        color: '#153d6e',
        cursor: Platform.OS.equals('web') ? 'pointer' : undefined,
        fontFamily: 'GothamBook',
        fontSize: Platform.OS.equals('web') ? '16pt' : 16,
        lineHeight: Platform.OS.equals('web') ? '18pt' : 18,
        textDecorationLine: 'none'
    }
});

Link.propTypes = {
    onPress: PropTypes.func,
    style: PropTypes.object,
    text: PropTypes.string.isRequired
};

export default Link;
